import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Checkbox, Popconfirm, Radio, Space, Tag } from "antd";
import { useMemo, useState } from "react";
import { useI18n } from "../../../contexts/i18n.js";
import { useListTcfVendor } from "../../../contexts/listTcfVendor.js";
const ListTcfNetworkItem = (adNetwork)=>{
    const contextValue = useListTcfVendor();
    const { view, rows } = contextValue;
    const { __, _n } = useI18n();
    const { name, description, provider, lists, hasRealTimeApi, updatedAt, createContentBlockerForVendorId, onCreateOrEditContentBlocker, onCreate } = adNetwork;
    const [selectedItem, setSelectedItem] = useState(()=>lists.filter(({ isRecommended, name })=>isRecommended && name)[0]?.name);
    const vendorWithBlocker = useMemo(()=>view === "vendors" ? rows.filter(({ vendor: { id }, blocker })=>id === createContentBlockerForVendorId && blocker !== false)[0] : undefined, [
        view,
        rows,
        createContentBlockerForVendorId
    ]);
    const [isCreateContentBlocker, setIsCreateContentBlocker] = useState(!!onCreateOrEditContentBlocker && !vendorWithBlocker);
    const { lang } = document.documentElement;
    const [selectedItemObject] = lists.filter(({ name })=>name === selectedItem);
    return /*#__PURE__*/ _jsxs(Space, {
        direction: "vertical",
        children: [
            /*#__PURE__*/ _jsxs("p", {
                className: "description",
                children: [
                    description,
                    /*#__PURE__*/ _jsx("br", {}),
                    /*#__PURE__*/ _jsx("br", {}),
                    __("Only advertising partners to whom your website visits have consented can participate in the auction. For advertising partners who require consent in accordance with the TCF standard, the respective TCF vendors must be configured."),
                    /*#__PURE__*/ _jsx("br", {}),
                    /*#__PURE__*/ _jsx("br", {}),
                    __("You can automatically import these lists of TCF vendor configurations:")
                ]
            }),
            /*#__PURE__*/ _jsx(Radio.Group, {
                value: selectedItem,
                onChange: (e)=>setSelectedItem(e.target.value),
                children: /*#__PURE__*/ _jsx(Space, {
                    direction: "vertical",
                    children: lists.map(({ name, description, isRecommended, vendorIds: { length } })=>/*#__PURE__*/ _jsxs(Radio, {
                            value: name,
                            children: [
                                /*#__PURE__*/ _jsxs("div", {
                                    children: [
                                        name,
                                        " (",
                                        _n("%d TCF vendor", "%d TCF vendors", length, length),
                                        ")",
                                        " ",
                                        isRecommended && /*#__PURE__*/ _jsx(Tag, {
                                            color: "blue",
                                            children: __("Recommended")
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsx("p", {
                                    className: "description",
                                    children: description
                                })
                            ]
                        }, name))
                })
            }),
            /*#__PURE__*/ _jsx("p", {
                className: "description",
                children: /*#__PURE__*/ _jsxs("i", {
                    children: [
                        __("Last updated: %s", new Date(updatedAt).toLocaleDateString(lang)),
                        "\xa0•\xa0",
                        !hasRealTimeApi && __("%s does not offer an API for real-time updates.", provider)
                    ]
                })
            }),
            onCreateOrEditContentBlocker && !vendorWithBlocker && /*#__PURE__*/ _jsx(Checkbox, {
                checked: isCreateContentBlocker,
                onChange: (e)=>setIsCreateContentBlocker(e.target.checked),
                children: __('Create content blocker for %s (blocks scripts until consent for purpose "Store and/or access information on a device" is given for this TCF vendors)', name)
            }),
            /*#__PURE__*/ _jsx("div", {
                style: {
                    textAlign: "right"
                },
                children: selectedItemObject && /*#__PURE__*/ _jsx(Popconfirm, {
                    title: /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            __("After activating the TCF vendors, I will check the information for each activated TCF vendor in the TCF vendor configuration myself and correct any information that does not match my use case."),
                            isCreateContentBlocker && /*#__PURE__*/ _jsxs(_Fragment, {
                                children: [
                                    /*#__PURE__*/ _jsx("br", {}),
                                    /*#__PURE__*/ _jsx("br", {}),
                                    __("In addition, I'll checked the information in the content blocker  myself for correctness and completeness and add missing information or corrected information that does not fit my use case. I am aware that the manufacturer of Real Cookie Banner cannot take any liability in this respect.")
                                ]
                            })
                        ]
                    }),
                    overlayInnerStyle: {
                        maxWidth: 300
                    },
                    placement: "bottomLeft",
                    onConfirm: async ()=>{
                        await onCreate({
                            adNetwork,
                            list: selectedItemObject
                        });
                        if (isCreateContentBlocker && !vendorWithBlocker) {
                            setTimeout(()=>{
                                onCreateOrEditContentBlocker();
                            }, 0);
                        }
                    },
                    okText: __("Create"),
                    cancelText: __("Cancel"),
                    children: /*#__PURE__*/ _jsx("a", {
                        className: "button button-primary",
                        children: __("Create TCF vendor configurations")
                    })
                })
            })
        ]
    });
};
export { ListTcfNetworkItem };
